// src/polyfills/node-globals.ts
import { Buffer } from 'buffer';
import process from 'process';

if (typeof window !== 'undefined') {
  (window as any).global = window;
  (window as any).process = {
    ...process,
    env: process.env || {},
    version: '16.0.0', // Fake version to satisfy semver checks
  };
  (window as any).Buffer = Buffer;
}
